
import { defineComponent } from 'vue'
import IconBase from '@/vue/icons/IconBase.vue'

export default defineComponent({
  name: 'IconMessage',
  components: {
    IconBase,
  },
  setup() {
    return {
      d: 'M256 32C115 32 0 125 0 240c0 48 20 91 53 126-15 40-46 73-46 74a24 24 0 0017 40c62 0 110-26 139-46 29 9 60 14 93 14 141 0 256-93 256-208S397 32 256 32zm0 368c-27 0-53-4-78-12l-23-7-20 13c-14 11-33 22-57 30 7-13 14-26 20-41l10-28-20-22c-18-19-40-51-40-93 0-88 93-160 208-160s208 72 208 160-93 160-208 160z',
    }
  },
})
